import { useState, useEffect, useContext } from "react";
import axios from "axios";
import moment from "moment-timezone";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import Loader from "../layout/Loader";
import Alert from "../Alert";
import Pagination from "../layout/Pagination";
import ConfigureRoleForm from "./ConfigureRoleForm";
import { alertContext } from "../contexts/AlertProvider";
import PermissionGate from "../layout/PermissionGate";

const ConfigureRoles = () => {
  const [data, setData] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [search, setSearch] = useState("");
  const [role, setRole] = useState({});
  const [error, setError] = useState({});
  const [popup, setPopup] = useState("");
  const [_, setAlertConfig] = useContext(alertContext);
  const token = localStorage.getItem("token");
  const limit = process.env.REACT_APP_PAGINATION_LIMIT;

  const fetchRoles = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_ENDPOINT}role/get?page=${page}&limit=${limit}&search=${search}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.code === 1) {
          if (page > 1) {
            if (res.data.data.length === 0) {
              setPage(page - 1);
            } else {
              setData(res.data.data);
              setCount(res.data.count);
            }
          } else {
            setData(res.data.data);
            setCount(res.data.count);
          }
          fetchPermissions();
        } else {
          setIsLoading(false);
        }
      })
      .catch(console.error);
  };
  const fetchPermissions = () => {
    axios
      .get(`${process.env.REACT_APP_API_ENDPOINT}role/permissions`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.data.code === 1) {
          setPermissions(res.data.data);
          setIsLoading(false);
        }
      })
      .catch(console.error);
  };
  const validateRole = (action) => {
    const errors = {};
    if (role?.name === undefined || role?.name === null || role?.name === "") {
      errors["name"] = "Please enter name.";
    }
    if (
      role?.permissions !== undefined &&
      role?.permissions !== null &&
      !Array.isArray(role?.permissions)
    ) {
      errors["permissions"] = "Please select permissions.";
    }

    setError(errors);
    if (Object.keys(errors).length === 0) {
      if (action === "add") {
        addRole(role);
      } else if (action === "edit") {
        updateRole(role);
      }
    }
  };
  const addRole = (payload) => {
    axios
      .post(`${process.env.REACT_APP_API_ENDPOINT}role/create`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.data.code === 1) {
          setAlertConfig({
            show: true,
            message: res.data.message,
            type: "success",
          });
          setPopup("");
          setRole({});
          setError({});
          fetchRoles();
        } else {
          setAlertConfig({
            show: true,
            message: res.data.message,
            type: "danger",
          });
        }
      })
      .catch(console.error);
  };
  const updateRole = (payload) => {
    axios
      .put(
        `${process.env.REACT_APP_API_ENDPOINT}role/update/${payload?._id}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.code === 1) {
          setPopup("");
          setRole({});
          setError({});
          fetchRoles();
        }
      })
      .catch(console.error);
  };
  const processData = (type, event, field) => {
    if (type === "text") {
      const value = event.target.value;
      const newData = { ...role };
      newData[field] = value;
      const newError = { ...error };
      newError[field] = "";
      delete newError[field];
      setRole({ ...newData });
      setError({ ...newError });
    }
    if (type === "permissions") {
      const checked = event.target.checked;
      const value = event.target.value;
      if (value === "all") {
        if (checked) {
          setRole({
            ...role,
            permissions: permissions,
          });
        } else {
          setRole({
            ...role,
            permissions: [],
          });
        }
      } else {
        if (checked) {
          setRole({
            ...role,
            permissions: [...(role?.permissions || []), value],
          });
        } else {
          setRole({
            ...role,
            permissions: (role?.permissions || []).filter((p) => p !== value),
          });
        }
      }
      const newError = { ...error };
      newError[field] = "";
      delete newError[field];
      setError({ ...newError });
    }
  };
  const openPopup = (action, data) => {
    setRole(data);
    setPopup(action);
  };
  const deleteRole = () => {
    if (role._id !== undefined) {
      axios
        .delete(
          `${process.env.REACT_APP_API_ENDPOINT}role/delete/${role?._id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          if (res.data.code === 1) {
            setPopup("");
            setRole({});
            fetchRoles();
          }
        })
        .catch(console.error);
    }
  };

  useEffect(() => {
    fetchRoles();
  }, [page, search]);
  return isLoading === true ? (
    <Loader />
  ) : (
    <div className="d-flex flex-column flex-root">
      <Alert />
      {/*begin::Page*/}
      <div className="page d-flex flex-row flex-column-fluid">
        {/*begin::Wrapper*/}
        <div
          className="wrapper d-flex flex-column flex-row-fluid"
          id="kt_wrapper"
        >
          <Header />
          <div className="app-body">
            <div className="toolbar py-3 py-lg-6" id="kt_toolbar">
              {/*begin::Container*/}
              <div
                id="kt_toolbar_container"
                className=" container-xxl  d-flex flex-stack flex-wrap gap-2"
              >
                {/*begin::Page title*/}
                <div className="page-title d-flex flex-column align-items-start me-3 py-2 py-lg-0 gap-2">
                  {/*begin::Title*/}
                  <h1 className="d-flex text-dark fw-bold m-0 fs-3">
                    Configure Roles
                  </h1>
                  {/*end::Title*/}
                </div>
                {/*end::Page title*/}
                {/*begin::Actions*/}
                <div className="d-flex align-items-center overflow-auto text-nowrap">
                  {/*begin::Button*/}
                  <PermissionGate
                    required={`add_new_user_role`}
                    fallback={<></>}
                  >
                    <button
                      onClick={() => {
                        setPopup("add");
                        setRole({});
                      }}
                      className="btn btn-color-success bg-body mx-3"
                    >
                      <i className="ki-duotone ki-plus-circle text-success-700 fs-1">
                        <span className="path1"></span>
                        <span className="path2"></span>
                      </i>
                      Add New
                    </button>
                  </PermissionGate>
                  {/*end::Button*/}
                </div>
                {/*end::Actions*/}
              </div>
              {/*end::Container*/}
            </div>
            {/*end::Toolbar*/}

            {/*begin::Container*/}
            <div
              id="kt_content_container"
              className="d-flex flex-column-fluid align-items-start  container-xxl "
            >
              {/*begin::Post*/}
              <div className="content flex-row-fluid" id="kt_content">
                {/*begin::Card*/}
                <PermissionGate required={`view_user_role_list`}>
                  <div className="card">
                    {/*begin::Card header*/}
                    <div className="card-header border-0 pt-6">
                      {/*begin::Search*/}
                      <div className="my-1 w-100">
                        <input
                          value={search}
                          onChange={(e) => {
                            setSearch(e.target.value);
                          }}
                          type="text"
                          data-kt-user-table-filter="search"
                          className="form-control w-100"
                          placeholder="Search Role"
                        />
                      </div>
                      {/*end::Search*/}
                    </div>
                    {/*end::Card header*/}

                    {/*begin::Card body*/}
                    <div className="card-body py-4 text-center">
                      {/*begin::Table*/}
                      {data?.length === 0 ? (
                        <div className="text-center w-100">
                          <img
                            className="w-25 mx-auto py-20"
                            src={`${process.env.REACT_APP_PUBLIC_URL}assets/media/misc/no-content.png`}
                            alt="no-content"
                          />
                        </div>
                      ) : (
                        <div className="table-responsive">
                          <table
                            className="table align-middle table-row-dashed fs-6 gy-5"
                            id="kt_table_users"
                          >
                            <thead>
                              <tr className="text-muted fw-bold fs-7 text-uppercase gs-0">
                                <th className="text-center min-w-100px">
                                  Role Name
                                </th>
                                <th className="text-center min-w-100px">
                                  Total Permissions
                                </th>
                                <th className="text-center min-w-100px">
                                  Total Users
                                </th>
                                <th className="text-center min-w-100px">
                                  Created At
                                </th>
                                <th className="text-center min-w-100px">
                                  Last Updated
                                </th>
                                <th className="text-center min-w-100px">
                                  Actions
                                </th>
                              </tr>
                            </thead>
                            <tbody className="text-gray-600 fw-semibold">
                              {data &&
                                data.map((item, index) => {
                                  return (
                                    <tr className="text-center" key={index}>
                                      <td>{item?.name}</td>
                                      <td>
                                        {item?.name !== "owner" &&
                                        Array.isArray(item?.permissions)
                                          ? item?.permissions?.length
                                          : "---"}
                                      </td>
                                      <td>{item?.users ?? 0}</td>
                                      <td>
                                        {moment(item.createdAt)
                                          .tz(process.env.REACT_APP_TIMEZONE)
                                          .format("Do MMM, YYYY, hh:mm A")}
                                      </td>
                                      <td>
                                        {moment(item.updatedAt)
                                          .tz(process.env.REACT_APP_TIMEZONE)
                                          .format("Do MMM, YYYY hh:mm A")}
                                      </td>
                                      <td className="">
                                        <div className="btn-group">
                                          {/*begin::Edit*/}
                                          <PermissionGate
                                            required={`edit_user_role`}
                                            fallback={<></>}
                                          >
                                            <button
                                              onClick={() => {
                                                openPopup("edit", item);
                                              }}
                                              className="btn px-2 btn-outline btn-primary btn-color-white btn-sm"
                                              data-bs-toggle="tooltip"
                                              data-bs-placement="top"
                                              title="Edit"
                                              disabled={item?.name === "owner"}
                                            >
                                              <i className="bi-duotone bi-pen fs-5"></i>
                                            </button>
                                          </PermissionGate>
                                          {/*end::Edit*/}
                                          {/*begin::Delete*/}
                                          <PermissionGate
                                            required={`delete_user_role`}
                                            fallback={<></>}
                                          >
                                            <button
                                              onClick={() => {
                                                openPopup("delete", item);
                                              }}
                                              className="btn px-3 btn-outline btn-danger btn-color-white btn-sm"
                                              data-bs-toggle="tooltip"
                                              data-bs-placement="top"
                                              title="Delete"
                                              disabled={item?.name === "owner"}
                                            >
                                              <i className="bi-duotone bi-trash fs-5"></i>
                                            </button>
                                          </PermissionGate>
                                          {/*end::Delete*/}
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                })}
                            </tbody>
                          </table>
                        </div>
                      )}

                      {/*end::Table*/}
                      {/*begin::Paginate*/}
                      {count && Math.ceil(count / limit) > 1 ? (
                        <Pagination
                          page={page}
                          setPage={setPage}
                          count={count}
                          limit={limit}
                        />
                      ) : (
                        ""
                      )}
                      {/*end::Paginate*/}
                    </div>
                    {/*end::Card body*/}
                  </div>
                </PermissionGate>
                {/*end::Card*/}
              </div>
              {/*end::Post*/}
            </div>
          </div>
          {/* start :: add */}
          <ConfigureRoleForm
            popup={popup}
            setPopup={setPopup}
            role={role}
            setRole={setRole}
            processData={processData}
            error={error}
            setError={setError}
            action={validateRole}
            permissions={permissions}
          />
          {/* end :: add */}
          {/* start :: edit */}
          <ConfigureRoleForm
            popup={popup}
            setPopup={setPopup}
            role={role}
            setRole={setRole}
            processData={processData}
            error={error}
            setError={setError}
            action={validateRole}
            permissions={permissions}
          />
          {/* end :: edit */}
          {/* start :: delete */}
          <div
            className={
              popup === "delete" ? "modal fade show d-block" : "modal fade"
            }
            tabIndex={-1}
          >
            <div className="modal-dialog modal-dialog-centered modal-sm">
              <div className="modal-content text-center bg-danger text-light">
                <div className="modal-header">
                  <h5 className="modal-title mx-auto text-light">DELETE</h5>
                </div>
                <div className="modal-body">
                  <p className="h4 text-light">Are You Sure ?</p>
                </div>
                <div className="modal-footer justify-content-center">
                  <button
                    onClick={() => {
                      setRole({});
                      setPopup("");
                    }}
                    type="button"
                    className="btn btn-light btn-sm"
                    data-bs-dismiss="modal"
                  >
                    No
                  </button>
                  <button
                    type="button"
                    className="btn btn-light btn-sm"
                    onClick={deleteRole}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* end :: delete */}
          <Footer />
        </div>
        {/*end::Wrapper*/}
      </div>
      {/*end::Page*/}
    </div>
  );
};

export default ConfigureRoles;
